export default {"src":"/_next/static/media/bfc_icon.25676913.svg","height":38,"width":26,"blurWidth":0,"blurHeight":0};